import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Radium from 'radium';

const propTypes = {}

const defaultProps = {
    text: '',
    editMode: true,
}

const styles = {
    headingStyle: {
        fontSize: 14,
        fontWeight: 600,
    },
    input: {
        border: 'none',
        outline: 'none',
        height: 19,
        '-webkit-box-shadow': 'none',
        '-moz-box-shadow': 'none',
        'box-shadow': 'none',
        fontWeight: 600,
        ':focus': {
            border: 'none',
            outline: 'none',
        }
    },
    text: {
        fontSize: 14,
        fontWeight: 600,
        height: 19,
        paddingLeft: 5,
        paddingBottom: 19,
        paddingTop: 1,
    },
}

class Heading extends Component {
    setEditMode = () => {
        this.props.setEditMode(true, '1')
        setTimeout(() => this.myInp ? this.myInp.focus() : () => { }, 100)
    }

    onBlur = () => {
        const { text } = this.props
        if (text.length > 0) {
            this.props.setEditMode(!this.props.editMode, '1')
        }
    }

    handleKeyPress = (event) => {
        if (event.key == 'Enter') {
            this.onBlur()
        }
    }

    onChange = (e) => {
        const { onChange } = this.props
        onChange(e.target.value)
    }

    render() {
        const { text, style } = this.props
        return (
            <div
                style={styles.headingStyle}
                onClick={this.setEditMode}
            >
                {
                    this.props.editMode ?
                        <input
                            type="text"
                            ref={(ip) => this.myInp = ip}
                            style={[styles.input, style]}
                            value={text}
                            placeholder="Tilføj overskrift"
                            onChange={this.onChange}
                            onBlur={this.onBlur}
                            onFocus={this.setEditMode}
                            onKeyPress={this.handleKeyPress}
                        /> :
                        <div style={[styles.text, style]}>
                            {text}
                        </div>
                }
            </div>
        )
    }
}

Heading.propTypes = propTypes

Heading.defaultProps = defaultProps

export default Radium(Heading)


// WEBPACK FOOTER //
// ./src/App/HeadingSubtext/Heading.js